module.exports = __webpack_public_path__ + "static/media/zain.319704a9.svg";